var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params) ? _c('el-dialog', {
    staticClass: "scoped-interivew-email",
    attrs: {
      "title": _vm.senderTitle,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPreview),
      expression: "!isPreview"
    }],
    key: _vm.renderKey,
    staticClass: "editView"
  }, [(_vm.params.userAttributes === 4) ? _c('div', {
    staticStyle: {
      "width": "85%",
      "margin": "0px auto 20px"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.supplierList
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "供应商",
      "width": "100",
      "prop": "supplierName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "候选人数量",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.rpIdList.length))]
      }
    }], null, false, 3940408418)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "对接人(点击名字标签可发送给该对接人)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.contactList), function(item, index) {
          return _c('el-tag', {
            key: index,
            staticClass: "user-tag",
            class: {
              'disabled': item.disabled === true
            },
            nativeOn: {
              "click": function($event) {
                return _vm.togglerUserActive(item)
              }
            }
          }, [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.email) + ")")])
        })
      }
    }], null, false, 311185674)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.previewEmailSupplier(scope.row)
            }
          }
        }, [_vm._v("预览")])]
      }
    }], null, false, 3920799250)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.baseData) ? _c('el-form', {
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择模板",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择模板"
    },
    on: {
      "change": _vm.selectedTpl
    },
    model: {
      value: (_vm.selectTpl),
      callback: function($$v) {
        _vm.selectTpl = $$v
      },
      expression: "selectTpl"
    }
  }, _vm._l((_vm.baseData.list), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.interviewArrangeForms.length && !_vm.isMultiEmail && _vm.isInterviewPhase && _vm.showInterviewPhase) ? _c('el-form-item', {
    attrs: {
      "label": "面试阶段",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-checkbox', {
    staticClass: "mr-20",
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAllParse),
      callback: function($$v) {
        _vm.checkAllParse = $$v
      },
      expression: "checkAllParse"
    }
  }, [_vm._v("全选\n                ")]), _vm._v(" "), _c('el-checkbox-group', {
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "change": _vm.handleCheckedPharseChange
    },
    model: {
      value: (_vm.filterIntViewArrIds),
      callback: function($$v) {
        _vm.filterIntViewArrIds = $$v
      },
      expression: "filterIntViewArrIds"
    }
  }, _vm._l((_vm.interviewArrangeForms), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v("\n                        " + _vm._s(item.turnName) + "\n                    ")])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.params.userAttributes !== 4) ? _c('el-form-item', {
    attrs: {
      "label": "收件人",
      "label-width": _vm.formLabelWidth
    }
  }, [(_vm.params.userAttributes === 2) ? _c('user-group', {
    ref: "sendEmail",
    attrs: {
      "allowEmail": true,
      "cacheOptions": _vm.interviewerUsers
    },
    model: {
      value: (_vm.form.sendEmail),
      callback: function($$v) {
        _vm.$set(_vm.form, "sendEmail", $$v)
      },
      expression: "form.sendEmail"
    }
  }) : _c('div', [(_vm.isMultiEmail) ? _c('div', _vm._l((_vm.baseData.resumePositionList), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "mr-5",
      nativeOn: {
        "click": function($event) {
          return _vm.previewEmail(item.id, index)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.resume.name) + "（" + _vm._s(item.resume.email) + "）"), _c('b', [_vm._v("【预览】")])])
  }), 1) : _c('div', _vm._l((_vm.baseData.resumePositionList), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "mr-5"
    }, [_vm._v("\n                            " + _vm._s(item.resume.name) + "（" + _vm._s(item.resume.email) + "）\n                        ")])
  }), 1)])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "抄送人",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('user-group', {
    ref: "ccList",
    attrs: {
      "cacheOptions": _vm.ccUsers,
      "allowEmail": true
    },
    model: {
      value: (_vm.form.ccList),
      callback: function($$v) {
        _vm.$set(_vm.form, "ccList", $$v)
      },
      expression: "form.ccList"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件标题",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "maxlength": 200
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "附件",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('file-upload', {
    staticClass: "upload-desc",
    attrs: {
      "action": ((_vm.$axios.defaults.baseURL) + "/payment/template/fileInsert.api")
    },
    model: {
      value: (_vm.fileList),
      callback: function($$v) {
        _vm.fileList = $$v
      },
      expression: "fileList"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件内容",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticClass: "quickTool"
  }, _vm._l((_vm.baseData.mailHolder), function(item, key) {
    return _c('el-tag', {
      key: key,
      attrs: {
        "icon": "el-icon-plus",
        "size": "small"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$refs.editor.addAfterCursor(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.text) + "\n                    ")])
  }), 1), _vm._v(" "), _c('vueditor', {
    ref: "editor",
    model: {
      value: (_vm.form.contentCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "contentCode", $$v)
      },
      expression: "form.contentCode"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isPreview) ? _c('div', {
    staticClass: "previewView"
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #ddd"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("邮件标题：" + _vm._s(_vm.form.name))]), _vm._v(" "), _c('p', [_vm._v("收件人："), _vm._l((_vm.interviewerUsers), function(item, index) {
    return _c('span', {
      key: item.id
    }, [_vm._v(_vm._s(item.name)), (index < _vm.interviewerUsers.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('p', [_vm._v("抄送人："), _vm._l((_vm.ccUsers), function(item, index) {
    return _c('span', {
      key: item.id
    }, [_vm._v(_vm._s(item.name)), (index < _vm.ccUsers.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  })], 2)]), _vm._v(" "), (_vm.form.hrAttachIds.length || _vm.form.mailAttachInfos.length) ? _c('p', [_vm._v("\n            附件：\n            "), (_vm.form.hrAttachIds.length) ? _c('span', _vm._l((_vm.getAttachItems), function(item, index) {
    return _c('span', {
      key: item.id,
      staticClass: "mr-5"
    }, [_vm._v(_vm._s(item.name)), (index < _vm.getAttachItems.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.form.mailAttachInfos.length) ? _c('span', _vm._l((_vm.form.mailAttachInfos), function(item, index) {
    return _c('span', {
      key: item.id,
      staticClass: "mr-5"
    }, [_vm._v(_vm._s(item.fileName)), (index < _vm.form.mailAttachInfos.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #ddd"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.form.content)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showPreviewBtn) ? _c('el-button', {
    staticClass: "left",
    attrs: {
      "type": "success"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.previewAll($event)
      }
    }
  }, [_vm._v("预 览")]) : _vm._e(), _vm._v(" "), (!_vm.isPreview) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]) : _vm._e(), _vm._v(" "), (_vm.isPreview) ? _c('el-button', {
    staticClass: "left",
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.toEditView
    }
  }, [_vm._v("返 回")]) : _vm._e(), _vm._v(" "), (_vm.showSendBtn) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendEmailAll
    }
  }, [_vm._v("发 送")]) : _vm._e()], 1)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-074c5078"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/interviewerEmailDialog.vue
// module id = null
// module chunks = 